import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-nonpo-credit-note',
  templateUrl: './upload-nonpo-credit-note.component.html',
  styleUrls: ['./upload-nonpo-credit-note.component.scss']
})
export class UploadNonpoCreditNoteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
